import { Text } from '@bfa/common-ui';
import React from 'react';
import { ACQUISITION_LANDING_PAGE_EVENTS as EVENTS } from '../../utils/analytics/events';
import { ButtonAnalyticsLogger } from '../Analytics';
var WaitlistButton = function (_a) {
    var _b = _a.ctaText, ctaText = _b === void 0 ? 'Get on the list' : _b, onClick = _a.onClick, onCtaClickedText = _a.onCtaClickedText, shouldShowCheckIcon = _a.shouldShowCheckIcon, dataE2Eselector = _a.dataE2Eselector;
    if (shouldShowCheckIcon === undefined) {
        return null;
    }
    if (shouldShowCheckIcon) {
        return (React.createElement("span", null,
            React.createElement(Text, { as: "span", className: "icon-ipsy-check icon-bold", textAlign: "center", fontSize: "1.4rem", lineHeight: "2.1rem", borderRadius: "100%", backgroundColor: "#C5FFB2", width: "3rem", height: "3rem", p: "0.5rem", mb: "2rem" }),
            React.createElement(Text, { mt: "2rem" }, onCtaClickedText)));
    }
    return (React.createElement(ButtonAnalyticsLogger, { eventData: EVENTS.CLICK_ON_WAIT_LIST_BUTTON, ctaText: ctaText, onClick: onClick, dataE2Eselector: dataE2Eselector, dataTestId: dataE2Eselector }));
};
export default WaitlistButton;
